module.exports = __webpack_public_path__ + "static/media/experienceimage.c49954e6.webp";